// Extension is load-bearing: the alias is rewritten to a relative path, so
// from inside src/services/api/ a bare "@services/api" resolves to "./" (this
// directory) instead of api.js. CpAvailability.js does the same.
import { api } from "@services/api.js";
import type {
  GigsAvailabilitySubmitRequest,
  GigsAvailabilitySubmitResponse,
  GigsAvailabilityResponse,
  GigsHistoryResponse,
} from "@screens/Gigs/types";

/**
 * Dedicated per-feature api module — mirrors `src/services/api/CpAvailability.js`
 * rather than growing the ~1900-line `src/services/api.js` monolith further.
 * Device id / IDFA / auth / app-version headers are already attached to every
 * request by `src/services/api-utils.js`'s request interceptor; nothing here
 * needs to add them manually.
 */

export const getGigsAvailability = () =>
  api.get<GigsAvailabilityResponse>("/cpdb/gigs");

export const submitGigsAvailability = (
  payload: GigsAvailabilitySubmitRequest,
) =>
  api.post<GigsAvailabilitySubmitResponse>("/cpdb/gigs/availability", payload);

export const getGigsHistory = (month?: string) =>
  api.get<GigsHistoryResponse>(
    month ? `/cpdb/gigs/history?month=${month}` : "/cpdb/gigs/history",
  );
